export enum TicketStatus{
    Pending,
    Validated,
    Cancelled,
    Refunded,
}